import $ from 'jquery';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { getEntitySet } from './get-entity-set';

function initCreateInstrumentationActivity(instrumentation) {
  const senario = instrumentation.label.create();
  const createActivity = senario.createLabel.create();

  return createActivity;
}

/**
* Create label
 *
 * @param {Object} param - An object containing these default options
 * @param {Object} param.jsdata - jsdata which will be used in labelsDatasource
 * @param {Object} param.label - the label to be created
 * @param {String} param.instrumentation - instrumentation that already intilized
 * and which should contains the senario of label and activity of createLabel
 * @param {Object} param.edm - the edm reference
 * @param {Object} param.scope - the scope reference
 * @returns {Promise} result promise
*/
export function create({
  jsdata,
  label,
  instrumentation,
  edm,
  scope,
}) {
  const createActivity = initCreateInstrumentationActivity(instrumentation);
  const entitySet = getEntitySet(scope, edm, $, edmCampaign);
  return createActivity.monitorAsync(jsdata.Label.create(label, {
    cacheResponse: false,
    entitySet,
  }));
}
